import CircleControl from "@/components/Exercises/CircleOfControl/CircleControl";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/(content)/children/exercises/(shared)/circle-of-control/"
)({
  component: RouteComponent,
  head: () => ({
    meta: [
      {
        title: "Circle Of Control - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "circleControl.title",
    navbar: {
      showTitle: true,
    },
  }),
});

function RouteComponent() {
  return <CircleControl />;
}
